export const LEAD_LOCATION = 'Lead Location';
export const LEAD_SOURCE = 'Lead Source';
